import { useReferrerStore } from '../stores/useReferrerStore';

export default defineNuxtRouteMiddleware((_to, from) => {
  const referrer = useReferrerStore();
  referrer.setFrom(from.path);
});
